import { banners } from "../data/products";

function BannerIncidator({ index, active }) {
  return (
    <button
      type="button"
      data-bs-target="#bannerIndicators"
      data-bs-slide-to={index}
      className={active ? "active" : ""}
      aria-current={active}
    />
  );
}

function BannerImage({ image, active }) {
  return (
    <div
      className={"carousel-item " + (active ? "active" : "")}
      data-bs-interval="5000"
    >
      <div
        className="ratio"
        style={{ "--bs-aspect-ratio": "50%", maxHeight: "460px" }}
      >
        <img
          className="d-block w-100 h-100 bg-dark cover"
          alt=""
          src={image}
        />
      </div>
      <div className="carousel-caption d-none d-lg-block">
        <h5>An Phát</h5>
        <p>Nội thất tinh tế, bền vững theo thời gian.</p>
      </div>
    </div>
  );
}

function Banner() {
  return (
    <div
      id="bannerIndicators"
      className="carousel slide"
      data-bs-ride="carousel"
      style={{ marginTop: "56px" }}
    >
      <div className="carousel-indicators">
        {banners.map((banner, idx) => (
          <BannerIncidator key={banner.id} index={idx} active={idx === 0} />
        ))}
      </div>
      <div className="carousel-inner">
        {banners.map((banner, idx) => (
          <BannerImage key={banner.id} image={banner.image} active={idx === 0} />
        ))}
      </div>
    </div>
  );
}

export default Banner;
